import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CTAButton } from '../ui/CTAButton';
export function Hero() {
  return <section className="pt-16 pb-20 px-6 bg-brand-cream" data-id="element-46">
      <div className="max-w-4xl mx-auto text-center" data-id="element-47">
        <FadeIn data-id="element-48">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight" data-id="element-49">
            Salud Dorada: EL Protocolo De 14 Días
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-50">
          <h2 className="text-xl md:text-2xl mb-10 text-brand-brown/80 font-sans max-w-3xl mx-auto" data-id="element-51">
            Recupera la movilidad de tus manos, rodillas y cadera usando la
            "Bio-fusión Latina" sin depender de pastillas que dañan tu estómago.
          </h2>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-52">
          <div className="relative rounded-2xl overflow-hidden shadow-soft mb-12 max-w-3xl mx-auto border-4 border-white" data-id="element-53">
            <img src="https://cdn.magicpatterns.com/uploads/njUHBmEvP8D7323DRhHXjd/imagen_del_produt2_.png" alt="Salud Dorada Protocolo en Tablet y Teléfono" className="w-full h-auto object-cover" data-id="element-54" />
          </div>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-55">
          <CTAButton data-id="element-56">¡SÍ, QUIERO MI SALUD DORADA AHORA!</CTAButton>
          <p className="mt-4 text-sm text-brand-brown/60 font-medium" data-id="element-57">
            Acceso inmediato • Pago seguro
          </p>
        </FadeIn>
      </div>
    </section>;
}